<template>
  <div class="address">
    <div class="tableConBox">
      <div class="tableTem">
        <div class="HSpace1"></div>
        <div class="searchBox flex flex-align-center">
          <div class="searchCon clearfix">
            <div class="left searchBtn">
              <button type="button" @click="showUpBox(null)">
                <i class="el-icon-plus"></i>添加分类
              </button>
            </div>
          </div>
        </div>
        <div class="HSpace2"></div>
        <div class="tableBox">
          <div class="tableBoxScroll">
            <table class="titleTable">
              <tr>
                <th style="width: 20%; text-align: left; padding-left: 10%">
                  分类名称
                </th>
                <th style="width: 40%; text-align: left; padding-left: 10%">
                  排序值
                </th>
                <th style="width: 20%; text-align: left; padding-left: 10%">
                </th>
                <th style="width: 20%; text-align: right; padding-right: 10%">
                  操作
                </th>
              </tr>
            </table>
            <div class="scrollBox">
              <div class="scroll">
                <table
                  class="conTable"
                  :class="{ overLengthTable: listData.length > 10 }"
                >
                  <tr v-for="item in listData">
                    <td style="width: 20%; text-align: left; padding-left: 10%">
                      <span v-text="item.name"></span>
                    </td>
                    <td style="width: 40%; text-align: left; padding-left: 10%">
                      <span>{{ item.queue }}</span>
                    </td>
                    <td style="width: 20%; text-align: left; padding-left: 10%">
                    </td>
                    <td
                      style="width: 20%; text-align: right; padding-right: 10%"
                    >
                      <span
                        title="修改"
                        style="margin: 0 2%; cursor: pointer"
                        v-if="item.id"
                        @click="showUpBox(item)"
                        ><i class="iconfont icon-bianji"></i
                      ></span>
                      <span
                        title="删除"
                        style="cursor: pointer"
                        @click="delItem(item)"
                        v-if="item.id"
                        ><i class="iconfont icon-icon1460188478041"></i
                      ></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="'添加/编辑分类'" :visible.sync="addAddrBtn" size="tiny">
      <div>
        <div class="msgBox clearfix">
          <div class="left msgItem clearfix">
            <span class="left itemName"><i>*</i>分类名称</span>
            <input
              type="text"
              class="left itemInput"
              v-model="form.name"
              placeholder="请输入名称"
            />
          </div>
        </div>
        <div class="msgBox clearfix">
          <div class="left msgItem clearfix">
            <span class="left itemName"><i>*</i>分类排序</span>
            <input
              type="number"
              class="left itemInput"
              v-model="form.queue"
              placeholder="请输入"
            />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button type="button" @click="addAddrBtn = false" class="cancel">
          取消
        </button>
        <button type="button" @click="addAddrFn" class="save">保存</button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
export default {
  props: ["pageSize", "curStoreId"],
  data() {
    return {
      form: {
        id: 0,
        name: "",
        queue: "",
      },
      specs: [],
      defaultSpec: "",
      autoSpec: "",
      dialogVisible: false,
      addAddrBtn: false, //添加地址按钮
      listData: [], //地址列表
      addr: "", //收货地址
      name: "", //姓名
      phone: "",
      userName: "", //用户手机号
      id: "",
    };
  },

  methods: {
    modifySpec(type, index) {
      let specs = JSON.parse(JSON.stringify(this.specs));
      if (type == "add") {
        if (!String(this.autoSpec).trim()) {
          this.$message({
            message: "请输入规格名称",
            customClass: "error",
          });
          return;
        }
        specs.push(this.autoSpec);
        this.autoSpec = "";
      } else if (type == "del") {
        specs.splice(index, 1);
      }
      this.specs = specs;
    },
    //
    //删除地址
    delItem(item) {
      this.$confirm("此操作将删除该分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http({
            url: "delete/lease/type",
            method: "POST",
            data: {
              id: item.id,
            },
          }).then((res) => {
            this.getData();
          });
        })
        .catch(() => {});
    },
    //新建或更新地址
    addAddrFn(id) {
      if (!this.form.name) {
        this.$message({
          message: "请填写名称",
          customClass: "error",
        });
        return;
      }

      this.$http({
        url: "edit/lease/type",
        method: "POST",
        data: {
          id: this.form.id ? this.form.id : 0,
          name: this.form.name,
          queue: this.form.queue,
          sequence: this.form.queue,
          storeId: this.curStoreId,
        },
      }).then((res) => {
        this.getData();
        this.addAddrBtn = false;
        this.name = "";
        this.id = "";
        this.defaultSpec = "";
        this.specs = [];
        this.$message({
          message: "操作成功！",
          customClass: "success",
        });
      });
    },
    showUpBox(item) {
      if (item) {
        this.form.id = item.id;
        this.form.name = item.name;
        this.form.queue = item.queue;
      } else {
        this.form.id = "";
        this.form.name = "";
        this.form.queue = 0;
      }
      this.addAddrBtn = true;
    },
    getData() {
      this.$http({
        url: "lease/type/list",
        method: "POST",
        data: {
          storeId: this.curStoreId,
        },
      }).then((res) => {
        this.listData = res.data;
        if (this.listData.length < this.pageSize) {
          for (
            let i = 0, len = this.pageSize - this.listData.length;
            i < len;
            i++
          ) {
            this.listData.push({});
          }
        }
      });
    },
  },
  created: function () {
    this.userName = localStorage.getItem("username");
    for (let i = 0; i < this.pageSize; i++) {
      this.listData.push({});
    }
  },
  activated: function () {
    this.getData();
  },
};
</script>
<style lang="scss">
@import "../../../../../static/css/common.scss";
@import "../../../tableTemplate/tableTem.scss";
@import "../../../tableTemplate/el-dialog.scss";
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// index.vue?79b363be